import { render, staticRenderFns } from "./AffiliateProgram.vue?vue&type=template&id=977b5644&scoped=true"
import script from "./AffiliateProgram.vue?vue&type=script&lang=js"
export * from "./AffiliateProgram.vue?vue&type=script&lang=js"
import style0 from "./AffiliateProgram.vue?vue&type=style&index=0&id=977b5644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977b5644",
  null
  
)

export default component.exports